(function() {
  var moment, replacements;

  if (typeof require === "function") {
    moment = require("moment");
  } else {
    moment = this.moment;
  }

  moment.fn.toDateNumber = function() {
    return Number(this.format("YYYYMMDD"));
  };

  moment.fromDateNumber = function(dateNumber) {
    return moment(dateNumber, "YYYYMMDD");
  };

  if (typeof module !== "undefined" && module !== null) {
    module.exports = moment;
  } else {
    this.moment = moment;
  }
}.call(this));
